import api from '../../api';
export default {
  state: {
    showModalNewAddress: false,
    typeActionModalAddress: '',
    cartAddress: [],
    delivery: {
      dateTime: {},
      address: {},
      zoneMethodId: ''
    },
    isHomeDelivery: false,
    cost: '',
    zones: []
  },
  getters: {
    delivery(state) {
      return state.delivery;
    },
    getAddress(state) {
      return state.cartAddress ? state.cartAddress.pop() : [];
    },
    getTypeActionModalAddress(state) {
      return state.typeActionModalAddress;
    },
    isHomeDelivery(state) {
      return state.isHomeDelivery;
    },
    getZones(state) {
      return state.zones;
    },
    getCost(state) {
      return state.cost;
    }
  },
  mutations: {
    setDateTimeDelivery(state, value) {
      state.delivery.dateTime = value;
    },
    setAddressDelivery(state, value) {
      state.delivery.address = value;
    },
    setShowModalNewAddress(state) {
      state.showModalNewAddress = !state.showModalNewAddress;
    },
    setCartAddress(state, value) {
      state.cartAddress = value;
    },
    setTypeActionModalAddress(state, value) {
      state.typeActionModalAddress = value;
    },
    changeIsHomeDelivery(state) {
      state.isHomeDelivery = !state.isHomeDelivery;
    },
    setZones(state, value) {
      state.zones = value;
    },
    setCost(state, value) {
      state.cost = value.cost;
      state.delivery.zoneMethodId = value.zoneId;
    }
  },
  actions: {
    async getUserAddresses({ commit, rootState }) {
      const idCustomer = rootState.customer.customer.id;
      try {
        const res = await api.getUserAddresses(idCustomer);
        commit('setCartAddress', res.data);
      } catch (error) {
        console.log(error);
      }
    },
    async addUserAddress({ commit, dispatch, rootState }, form) {
      const idCustomer = rootState.customer.customer.id;
      try {
        const res = await api.newUserAddress(idCustomer, form);
        if (res.status) {
          dispatch('getUserAddresses');
          commit('setShowModalNewAddress');
          commit('setTypeActionModalAddress', '');
        } else {
          console.log(res.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateUserAddress({ commit, dispatch, rootState }, form) {
      const idCustomer = rootState.customer.customer.id;
      try {
        await api.editUserAddress(idCustomer, form.id, form);
        dispatch('getUserAddresses');
        if (form.status !== 0) {
          commit('setShowModalNewAddress');
          commit('setTypeActionModalAddress', '');
        }
      } catch (error) {
        console.log(error);
      }
    },
    updateDateTimeDelivery({ commit }, payload) {
      commit('setDateTimeDelivery', payload);
    },
    updateAddressDelivery({ commit }, payload) {
      commit('setAddressDelivery', payload);
    },
    updateZones({ commit }, payload) {
      commit('setZones', payload);
    }
  }
};
